import styled from 'styled-components';
import {BGImageCenter} from '../../../../../../globalVariables/GlobalVariables';
import {getSpacing, getToken, getFontSize, getFontWeight, getPrimitive} from '@tickchak/react-share/app';
import {dFlex, flexColumn, alignEnd, justifyCenter, alignCenter, alignStart, dFlexColumn} from '../../../../../../globalVariables/GlobalFlex';
import {wrap} from '../../../../../../component/textEditor/TextEditor.css.js';
import zIndex from '../../../../../../globalVariables/zIndex';

const EDITOR_TITLE_HEIGHT = 32;
interface ImageProps {
    image?: string;
}

export const section = styled.div`
    ${dFlex}
    ${flexColumn}
    ${alignEnd}
    gap: ${getSpacing('spaceLg')};
    align-self: stretch;
`;

export const imageWrapper = styled.div`
    background: ${getPrimitive('turquoise.turquoise200')};
    border-radius: 10px;
    width: 100%;
    ${dFlex}
    ${justifyCenter}
    position: relative;
    margin-bottom: ${getSpacing('spaceLg')};
    margin-top: ${getSpacing('spaceSm')};
`;

export const image = styled.div<ImageProps>`
    position: absolute;
    border-radius: 10px;
    width: 160px;
    height: 160px;
    ${p => BGImageCenter(p.image, 'cover')}
`;

export const sectionHeader = styled.div`
    ${dFlexColumn}
    width: 100%;
    color: ${getToken('color.text.default')};
    margin-bottom: calc(var(--space-xl) - ${EDITOR_TITLE_HEIGHT/2}px);
`;

export const headerTitle = styled.p`
    font-weight: ${getFontWeight('bold')};
    font-size: ${getFontSize('body')};
`;

export const editorWrapper = styled.div`
    ${wrap}{
        background: ${getToken('color.bg.base')};
    }
    width: 100%;
    ${dFlex}
    padding: ${getSpacing('space2xl')} ${getSpacing('spaceXl')};
    ${flexColumn}
    ${justifyCenter}
    ${alignCenter}
    gap: ${getSpacing('space2xl')};
    align-self: stretch;
    border-radius: 10px;
    background: ${getToken('color.bg.surface.default')};
    position: relative;
`;
export const editorTitle = styled.div`
    ${dFlex}
    ${alignCenter}
    height: ${EDITOR_TITLE_HEIGHT}px;
    gap: 6px;
    position: relative;
    inset-inline-start: calc(var(--space-xl) + 18px);
    top: ${EDITOR_TITLE_HEIGHT/2}px;
    z-index: ${zIndex.baseRaised};
    border-radius: 100px;
    background: ${getToken('color.bg.base')};
    font-size: ${getFontSize('caption')};
    padding: ${getSpacing('spaceSm')};
    align-self: flex-start;
    &::before{
        content: '';
        width: 8.551px;
        height: 7.938px;
        border-radius: 2px;
        background: ${getPrimitive('turquoise.turquoise400')};
    }
`;

